import type { CmsLocaleInputType } from "@workspace/casino_core/schema";
import { useIsMobile } from "@workspace/frontend-ui";
import { type FC, lazy, Suspense } from "react";
import RewardCenterProvider from "../../actors/RewardCenterProvider";
import TranslationsProvider from "../../i18n/TranslationsProvider";
import RewardCenterPopover from "./RewardCenterPopover";
import RewardCenterSheet from "./RewardCenterSheet";

type Props = {
  isDevConsoleEnabled?: boolean;
  locale?: CmsLocaleInputType;
  site: string;
};

const RewardDevConsole = lazy(() => import("../RewardDevConsole"));

const RewardCenterWhiteboard: FC<Props> = ({
  isDevConsoleEnabled = false,
  locale,
  site,
}) => {
  const isMobile = useIsMobile();

  return (
    <RewardCenterProvider
      isDevConsoleEnabled={isDevConsoleEnabled}
      locale={locale}
      site={site}
    >
      {isMobile ? <RewardCenterSheet /> : <RewardCenterPopover />}
      {isDevConsoleEnabled && (
        <Suspense fallback={null}>
          <RewardDevConsole />
        </Suspense>
      )}
    </RewardCenterProvider>
  );
};

export default RewardCenterWhiteboard;
